import React from 'react';
import { Table } from 'react-bootstrap';

const MatchSummaryComponent = ({ fullMatch, meta, innings, summary }) => {
  return (
    <div className="brief-summary">
      <div className="innings-information">
        <div className="teams-and-score">
          <span className="team-name">{innings.inn1.batname}</span>
          {innings.inn1.bat === summary.batTmId ? (
            <span className="innings-1-score inning-score current-inning">{summary.sc}/{summary.wk} <span className="inning-over">({summary.ov})</span></span>
          ) : (
            <span className="innings-1-score inning-score past-inning">
              {innings.inn1.bat === meta.tm1Id ? `${fullMatch.match.t1Sc}/${fullMatch.match.t1Wkt} ` : `${fullMatch.match.t2Sc}/${fullMatch.match.t2Wkt} `}
              <span className="inning-over">({innings.inn1.bat === meta.tm1Id ? fullMatch.match.t1DispOv : fullMatch.match.t2DispOv})</span>
            </span>
          )}
        </div>
        <div className="teams-and-score">
          <span className="team-name">{innings.inn2.batname}</span>
          {innings.inn2.bat === summary.batTmId ? (
            <span className="innings-2-score inning-score current-inning">{summary.sc}/{summary.wk} <span className="inning-over">({summary.ov})</span></span>
          ) : (
            <span className="innings-2-score inning-score past-inning">
              {summary.inn === "1" ? "" : innings.inn1.bat === meta.tm1Id ? `${fullMatch.match.t2Sc}/${fullMatch.match.t2Wkt} ` : `${fullMatch.match.t1Sc}/${fullMatch.match.t1Wkt} `}
              <span className="inning-over">
                {summary.inn === "1"
                  ? ""
                  : summary.inn === "2"
                  ? ""
                  : innings.inn1.bat === meta.tm1Id
                  ? fullMatch.match.t2DispOv
                  : fullMatch.match.t1DispOv}
              </span>
            </span>
          )}
        </div>
        {summary.eq && <div className="equation">{summary.eq}</div>}
      </div>
      <div className="match-information">
        <div className="bold">
          {summary.tgt && (
            <div>
              <span>Target: </span>
              <span className="normal">{summary.tgt}</span>
            </div>
          )}
          <div>
            RR: <span className="normal">{summary.rr}</span>
          </div>
          {summary.rrr && (
            <div>
              RRR: <span className="normal">{summary.rrr}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const BriefScorecardComponent = ({ summary }) => {
  return (
    <div className="row">
      <div className="summary-score">
        <table className="score-table" width="100%">
          <tr>
            <td>
              <table width="100%">
                <thead>
                  <tr>
                    <th className="th-batsmen">Batsmen</th>
                    <th className="th-r">R</th>
                    <th className="th-b">B</th>
                    <th className="th-4s">4s</th>
                    <th className="th-6s">6s</th>
                    <th className="th-sr">SR</th>
                    <th className="non-mobile"></th>
                    <th className="non-mobile"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="row1">
                    <td className="batsman-1-name current-player">
                      <a
                        href={`/player?id=${summary.bat.on.id}`}
                        title="View the player profile for"
                        target="_blank"
                      >
                        {summary.bat.on.name}
                      </a>
                    </td>
                    <td className="bold">{summary.bat.on.r}</td>
                    <td>{summary.bat.on.b}</td>
                    <td>{summary.bat.on.f}</td>
                    <td>{summary.bat.on.s}</td>
                    <td>{summary.bat.on.sr}</td>
                    <td className="non-mobile"></td>
                    <td className="non-mobile"></td>
                  </tr>
                  <tr className="row2">
                    <td className="batsman-2-name ">
                      <a
                        href={`/player?id=${summary.bat.off.id}`}
                        title="View the player profile for"
                        target="_blank"
                      >
                        {summary.bat.off.name}
                      </a>
                    </td>
                    <td className="bold">{summary.bat.off.r}</td>
                    <td>{summary.bat.off.b}</td>
                    <td>{summary.bat.off.f}</td>
                    <td>{summary.bat.off.s}</td>
                    <td>{summary.bat.off.sr}</td>
                    <td className="non-mobile"></td>
                    <td className="non-mobile"></td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th className="th-bowlers">Bowler</th>
                    <th className="th-o">O</th>
                    <th className="th-m">M</th>
                    <th className="th-r">R</th>
                    <th className="th-w">W</th>
                    <th className="th-econ">Eco.</th>
                    <th className="th-4s non-mobile">4s</th>
                    <th className="th-6s non-mobile">6s</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="row1">
                    <td className="bowler-1-name current-player">
                      <a
                        href={`/player?id=${summary.bowl.id}`}
                        title="View the player profile for"
                        target="_blank"
                      >
                        {summary.bowl.name}
                      </a>
                    </td>
                    <td>{`${summary.bowl.o}.${summary.bowl.b}`}</td>
                    <td>{summary.bowl.m}</td>
                    <td>{summary.bowl.r}</td>
                    <td>{summary.bowl.w}</td>
                    <td>{summary.bowl.eco}</td>
                    <td className="non-mobile">{summary.bowl.f}</td>
                    <td className="non-mobile">{summary.bowl.s}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </table>
        <div className="more-match-stats">
          <div className="match-stat">
            <span className="head">Recent overs</span>
            {summary.recent.map((over, index) => (
              <span key={index} className="head" dangerouslySetInnerHTML={{__html:over}}>
                
              </span>
            ))}
          </div>
          {/*<div className="match-stat">
            <span className="head">Current Partnership</span>
            <span>
              {`${summary.currentPartnership.sc} runs, ${summary.currentPartnership.ov} overs (`}
              {summary.currentPartnership.bats.forEach((batsman) => (
                <span key={batsman.nm}>{`${batsman.nm} ${batsman.r}, `}</span>
              ))}
              )
            </span>
              </div>*/}
          {summary.lastWicket && (
            <>
              <div className="match-stat">
                <span className="head">Last Bat:</span>
                <span>{summary.lastWicket}</span>
              </div>
              <div className="match-stat">
                <span className="head">Last FOW:</span>
                <span>{summary.lastFow}</span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export { MatchSummaryComponent, BriefScorecardComponent };
